import './styles.css'

const GallowsComponent = () => (
  <div className='gallows-component'>
    <span className='foot' />
    <span className='root' />
    <span className='arm' />
    <span className='crossbar' />
  </div>
)

export default GallowsComponent